const ESTADO_STYLES = {
  all: { label: "Todos", bg: "#0d6efd", color: "#fff" },
  3: { label: "Chequear", bg: "#6c757d", color: "#fff" },
  4: { label: "Notificado", bg: "#198754", color: "#fff" },
  7: { label: "Incompleta", bg: "#dc3545", color: "#fff" },
  8: { label: "Reparto", bg: "#ffc107", color: "#111" },
  9: { label: "Sin entregar", bg: "#ffc107", color: "#111" },
  10: { label: "Aprobada", bg: "#0dcaf0", color: "#111" },
  11: { label: "Abonada", bg: "#198754", color: "#fff" },
  13: { label: "Descargo", bg: "#212529", color: "#fff" },
  18: { label: "Anulada", bg: "#dc3545", color: "#fff" },
  19: { label: "Dictaminada", bg: "#7b1fa2", color: "#fff" },
};

const getEstadoConfig = (estadoId, descripcion) => {
  const config = ESTADO_STYLES[estadoId] ?? {};

  return {
    label: descripcion || config.label || `Estado ${estadoId}`,
    bg: config.bg || "#6c757d",
    color: config.color || "#fff",
  };
};

const FilterEstadosMCD = ({ data = [], estadoSeleccionado, setEstadoSeleccionado, loading }) => {
  const estados = data.reduce((acc, item) => {
    const estadoId = item?.afm?.estado_id;

    if (!estadoId || acc.some((estado) => estado.estado_id === estadoId)) {
      return acc;
    }

    const descripcion = item?.estado?.descripcion || item?.estado?.nombre || item?.afm?.estado?.descripcion;
    const { label, bg, color } = getEstadoConfig(estadoId, descripcion);

    acc.push({
      estado_id: estadoId,
      estado: label,
      bg,
      color,
      cantidad: data.filter((row) => row?.afm?.estado_id === estadoId).length,
    });

    return acc;
  }, []);

  const total = data.length;

  return (
    <div className="d-flex flex-wrap gap-2 p-2">
      <button
        type="button"
        className="border-0 rounded-pill px-3 py-2 fw-semibold"
        disabled={loading}
        onClick={() => setEstadoSeleccionado("all")}
        style={{
          background: ESTADO_STYLES.all.bg,
          color: ESTADO_STYLES.all.color,
          opacity: estadoSeleccionado === "all" ? 1 : 0.45,
          cursor: loading ? "not-allowed" : "pointer",
        }}
      >
        {ESTADO_STYLES.all.label} ({total})
      </button>

      {estados.map((estado) => (
        <button
          type="button"
          key={estado.estado_id}
          className="border-0 rounded-pill px-3 py-2 fw-semibold"
          disabled={loading}
          onClick={() => setEstadoSeleccionado(estado.estado_id)}
          style={{
            background: estado.bg,
            color: estado.color,
            opacity: estadoSeleccionado === estado.estado_id ? 1 : 0.45,
            cursor: loading ? "not-allowed" : "pointer",
          }}
        >
          {estado.estado} ({estado.cantidad})
        </button>
      ))}
    </div>
  );
};

export default FilterEstadosMCD;
